import { klarityTokens } from "./klarity-tokens.ts";
import { contractLayout } from "./layouts/contract.ts";
import { proposalLayout } from "./layouts/proposal.ts";
import { technicalLayout } from "./layouts/technical.ts";
import type { ThemeVersionData } from "./tokens.ts";

export const klarityTechnical: { name: "Klarity Technical"; data: ThemeVersionData } = {
  name: "Klarity Technical",
  data: {
    tokens: klarityTokens,
    layouts: { technical: technicalLayout, proposal: proposalLayout, contract: contractLayout },
    advancedCss: "",
  },
};
